import React from 'react'

function RTI() {
  return (
    <div className='wh-100'>
      <div
        className="container py-5"
      >
        <div className="container">

          {/* Page Title */}
          <h2
            className="mb-4 fw-bold text-primary"
          // style={{
          //   color: "#1f5fa8",
          //   letterSpacing: "2px",
          // }}
          >
            Rights to Information Act
          </h2>

          {/* Links Section */}
          <div className="list-group border-0">

            <a
              href={`https://ambronex.in/images/RTI/RTIAct2005.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              Right to Information Act 2005 - English
            </a>

            <a
              href={`https://ambronex.in/images/RTI/rtiactenglishandtamil.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              Right to Information Act 2006 - Tamil & English
            </a>

            <a
              href={`https://ambronex.in/images/RTI/RTISecondAppealFormat.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-center"
            >
              <span
                className="me-3 d-inline-flex justify-content-center align-items-center"
                style={{
                  width: "28px",
                  height: "28px",
                  backgroundColor: "#2f7ed8",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <i className="bi bi-play"></i>
              </span>
              Second Appeal under Section 19(3) of Right to Information Act,2005
            </a>

          </div>
        </div>
      </div>
    </div>
  )
}

export default RTI